import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from "@/common/api.service"
import vm from '../../main.js'
import { SET_CONNECTED, SET_CURRENTPOINT, SET_PLAYING, SET_STARTTIMER, SET_CRASHED, SET_HISTORY, SET_BETS, SET_CURRENTBET, ADD_CHAT_MESSAGE, SET_CHAT, SET_TIMER_WAITING } from "./mutation.type"
import { SOCKET_numberupdate, SOCKET_crash, SOCKET_playing, SOCKET_startTimer, SOCKET_history, SOCKET_bets, SOCKET_won, SOCKET_addChat, SOCKET_initChat, SOCKET_timerWaiting } from "./action.type"
import { ToastProgrammatic as Toast } from 'buefy'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    connected: false,
    currentPoint: 1,
    crashed: false,
    startTimer: true,
    history: [],
    bets: [],
    currentBet: null,
    playing: false,
    chat: [],
    timerWaiting: null
  },
  mutations: {
    [SET_CONNECTED](state, data) {
      state.connected = data
    },
    [SET_CURRENTPOINT](state, data) {
      state.currentPoint = data
      state.crashed = false
      state.startTimer = false
    },
    [SET_PLAYING](state, data) {
      state.playing = data
    },
    [SET_STARTTIMER](state, data) {
      state.startTimer = data
    },
    [SET_CRASHED](state, data) {
      state.crashed = data
    },
    [SET_HISTORY](state, data) {
      state.history = data
    },
    [SET_BETS](state, data) {
      state.bets = data
    },
    [SET_CURRENTBET](state, data) {
      state.currentBet = data
    },
    [SET_CHAT](state, data) {
      state.chat = data
    },
    [ADD_CHAT_MESSAGE](state, data) {
      if(state.chat.length == 10) {
        state.chat.splice(0, 1)
      }
      state.chat.push(data)
    },
    [SET_TIMER_WAITING](state, data) {
      state.timerWaiting = data
    }
  },
  actions: {
    [SOCKET_startTimer](context, data) {
      context.commit(SET_STARTTIMER, data)
      if(data) {
        context.commit(SET_CRASHED, false)
      }
    },
    [SOCKET_playing](context, data) {
      context.commit(SET_PLAYING, data)
    },
    [SOCKET_numberupdate](context, data) {
      context.commit(SET_CURRENTPOINT, data)
    },
    [SOCKET_crash](context, data) {
      console.log(data)
      context.commit(SET_CURRENTPOINT, data)
      context.commit(SET_CRASHED, true)
      context.commit(SET_CURRENTBET, 0)
    },
    [SOCKET_history](context, data) {
      context.commit(SET_HISTORY, data)
    },
    [SOCKET_bets](context, data) {
      context.commit(SET_BETS, data)
    },
    [SOCKET_won](context, data) {
      context.commit(SET_CURRENTBET, 0)
      Toast.open({
        type: "is-success",
        message: `You cashed out: ${data}`
      })
    },
    [SOCKET_initChat](context, data) {
      context.commit(SET_CHAT, data)
    },
    [SOCKET_addChat](context, data) {
      context.commit(ADD_CHAT_MESSAGE, data)
    },
    [SOCKET_timerWaiting](context, data) {
      context.commit(SET_TIMER_WAITING, data)
    },
    'SOCKET_connect'(context) {
      context.commit(SET_CONNECTED, true)
    },
    'SOCKET_connect_error'(error) {
      console.log(error)
    },
    'SOCKET_disconnect'(context) {
      context.commit(SET_CONNECTED, false)
      context.commit(SET_PLAYING, false)
    }
  }
}
